export const getAmountWithCurrency = (currencyIso: string, amount: number | undefined) => {
  let currencySymbol = ''
  switch (currencyIso?.toLowerCase()) {
    case 'usd':
      currencySymbol = '$'
      break
    case 'eur':
      currencySymbol = '€'
      break
    case 'gbp':
      currencySymbol = '£'
      break
    case 'aud':
      currencySymbol = '$'
      break
  }
  if (!amount) return currencySymbol
  else
    return amount >= 0
      ? `${currencySymbol}${amount.toFixed(0).toLocaleString()}`
      : `-${currencySymbol}${(-1 * amount).toFixed(0).toLocaleString()}`
}
